// Lida do #v2-config que o _LayoutV2 escreve (a v2 não usa as variáveis globais do v1).
let _config = null;

export function config() {
    if (_config) {
        return _config;
    }

    try {
        _config = JSON.parse(document.getElementById('v2-config')?.textContent || '{}');
    } catch {
        _config = {};
    }

    _config.cultura = _config.cultura || document.documentElement.lang || 'pt-br';
    return _config;
}

export function url(caminho) {
    return `/${config().cultura}${caminho}`;
}

export function urlApi(caminho) {
    return `/api/${config().cultura}${caminho}`;
}

// Textos que o servidor manda em data-textos (JSON), já traduzidos pelos .resx.
export function textos(elemento) {
    try {
        return JSON.parse(elemento?.dataset.textos || '{}');
    } catch {
        return {};
    }
}

export function formatar(modelo, ...valores) {
    return (modelo || '').replace(/\{(\d+)\}/g, (_, i) => valores[Number(i)] ?? '');
}

// Página pré-renderizada (a pré-carga do app Android): o que conta visita ou chama terceiros espera a pessoa abrir a tela.
export function aoExibirPagina(funcao) {
    if (document.prerendering) {
        document.addEventListener('prerenderingchange', () => funcao(), { once: true });
    } else {
        funcao();
    }
}
